// Event Names
export const APPROPRIATENESS_TEST_VIEWED = "Appropriateness Test Viewed";
export const APPROPRIATENESS_TEST_CTA_CLICKED = "Appropriateness Test CTA Clicked";
export const APPROPRIATENESS_TEST_CLOSE_CLICKED = "Appropriateness Test Close Button Clicked";
